import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-primary to-primary-dark text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo & Description */}
          <div>
            <img
              src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/371f364bafb22cfd7e999f6790320862.png"
              alt="EZKA3K Logo"
              className="h-12 w-auto object-contain mb-4 brightness-0 invert"
            />
            <p className="text-white/80 text-sm leading-relaxed">
              Yeni nesil eğitim, koçluk ve gelişim merkezi. Fiziksel + Online + Psiko-Eğitim + İçerik Üretim tabanlı hibrit sistem.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Hızlı Linkler</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  Anasayfa
                </Link>
              </li>
              <li>
                <Link to="/hizmetler" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  Hizmetler
                </Link>
              </li>
              <li>
                <Link to="/paketler" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  Paketler & Üyelikler
                </Link>
              </li>
              <li>
                <Link to="/sistem" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  Sistem Nasıl Çalışır
                </Link>
              </li>
              <li>
                <Link to="/hakkimizda" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  Hakkımızda
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Hizmetler</h4>
            <ul className="space-y-2">
              <li className="text-white/80 text-sm">EZKA-Study</li>
              <li className="text-white/80 text-sm">EZKA-Coach</li>
              <li className="text-white/80 text-sm">EZKA-Class (Hedef 12)</li>
              <li className="text-white/80 text-sm">EZKA-Psy</li>
              <li className="text-white/80 text-sm">EZKA-MediaLab</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">İletişim</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-secondary mt-1"></i>
                <span className="text-white/80 text-sm">Cumhuriyet Mahallesi Metrobüs Durağı, Ezka3k Akros İstanbul, Beylikdüzü</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-phone-line text-secondary mt-1"></i>
                <span className="text-white/80 text-sm">0530 465 23 72</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-mail-line text-secondary mt-1"></i>
                <span className="text-white/80 text-sm">ezka3k@gmail.com</span>
              </li>
            </ul>

            {/* Social Media */}
            <div className="flex space-x-4 mt-6">
              <a
                href="https://www.instagram.com/ezka3k"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full border border-white/30 hover:bg-white hover:text-primary transition-all cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://www.facebook.com/ezka3k"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full border border-white/30 hover:bg-white hover:text-primary transition-all cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://www.youtube.com/@ezka3k"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full border border-white/30 hover:bg-white hover:text-primary transition-all cursor-pointer"
              >
                <i className="ri-youtube-fill text-lg"></i>
              </a>
              <a
                href="https://www.tiktok.com/@ezka3k"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full border border-white/30 hover:bg-white hover:text-primary transition-all cursor-pointer"
              >
                <i className="ri-tiktok-fill text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-white/60 text-sm">
              © 2025 EZKA3K. Tüm hakları saklıdır.
            </p>
            <div className="flex items-center space-x-6">
              <Link to="/kvkk" className="text-white/60 hover:text-white text-sm transition-colors cursor-pointer">
                KVKK
              </Link>
              <Link to="/gizlilik-politikasi" className="text-white/60 hover:text-white text-sm transition-colors cursor-pointer">
                Gizlilik Politikası
              </Link>
              <Link to="/cerez-politikasi" className="text-white/60 hover:text-white text-sm transition-colors cursor-pointer">
                Çerez Politikası
              </Link>
              <a 
                href="https://cdco.com.tr" 
                target="_blank" 
                rel="nofollow noopener noreferrer" 
                className="text-white/60 hover:text-white text-sm transition-colors cursor-pointer"
              >
                Bu web tasarım CDCO tarafından yapılmıştır
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
